





























































import Vue from "vue";
import { debounce } from "@/fp";
import { LabelTreshHold, MipCognniCombination } from "../data/model";
import { ref, Ref, computed } from "@vue/composition-api";
import ConfidenceInput from "../ConfidenceInput.vue";
export default Vue.extend({
  components: {
    /* ConfidenceInput */
  },
  props: ["item"],
  setup(props, { emit }) {
    const is_loading_label = ref(false);

    const _item = computed(() => props.item as MipCognniCombination);

    const label_last_value: Ref<Record<string, number>> = ref({});

    const on_level_changed = debounce(500)((value: string, label: any) => {
      let num_val = value.trim().length === 0 ? 67 : +value;
      const { min, max } = LabelTreshHold;
      num_val = num_val < min ? min : num_val > max ? max : num_val;
      label_last_value.value = {
        ...label_last_value.value,
        [label.labelId]: num_val,
      };
      label.last = num_val;
      emit("change_now_for_ui", { id: label.labelId, value: num_val });
      if (num_val !== label.confidenceThreshold) {
        changeThreshold(num_val, label);
      }
    });

    const changeThreshold = debounce(500)((value: number, label: any) => {
      const { min, max } = LabelTreshHold;
      value = value < min ? min : value > max ? max : value;
      if (value !== label.confidenceThreshold) {
        is_loading_label.value = true;
        emit("changeTrashHold", {
          id: label.labelId,
          value,
          done: () => {
            is_loading_label.value = false;
          },
        });
      }
    });
    const open_overrides_modal = () => {
      emit("open_override_modal", {
        label_id: _item.value.labelId,
        mip_label_id: _item.value.externalLabelId,
        label_name: _item.value.runtime.label_name,
        label_code: _item.value.runtime.parent_code,
      });
    };

    const override_desc = `<p>Configuring your "Override" settings prioritizes whether a file <b> with an existing MIP sensitivity label</b> will receive a new label through Cognni's automation.</p> <br/><p> Choosing a sensitivity label and selecting other sensitivity labels to override will determine whether to <b>keep or change</b> the sensitivity label on those file in the event of conflicting classifications</p>`;

    const confidence_desc = `<div><p>The value of this field will establish a <b>minimum</b> confidence level at
          which MIP sensitivity labels will be applied.<br/><br/>
          Cognni confidence levels can be found by:</p>
           <ul class="pl-5">
          <li class="list-disc">Entering file views in the platform</li>
          <li class="list-disc">Clicking on the file's category or subcategory
          </ul>
          </div>`;

    return {
      is_loading_label,
      on_level_changed,
      open_overrides_modal,
      override_desc,
      confidence_desc,
    };
  },
});
